import Stager from "../stager"
import ChooseAccount from "./chooseAccount"
import AccountType from "./accountType"
import ProfileImage from "./profileImage"
import AccountInfo from "./accountInfo"
import AgeLocation from "./ageLocation"
import GetVerified from "./getVerified"
import CheckEmail from "./checkEmail"
import ConfirmEmail from "./confirmEmail"
import AuthPlan from "./authPlan"
import { mapGetters, mapState, mapActions } from "vuex"

export default {
  components: {
    Stager,
    ChooseAccount,
    AccountType,
    ProfileImage,
    AccountInfo,
    AgeLocation,
    GetVerified,
    CheckEmail,
    ConfirmEmail,
    AuthPlan,
  },
  data() {
    return {
      userEmail: "",
    }
  },
  computed: {
    ...mapState({
      accountCategory: state => state.app.onboarding.accountCategory,
      current: state => state.app.onboarding.current,
    }),
    ...mapGetters({
      stages:"app/onboardingStages",
      currentStage:"app/onboardingCurrentStage",
      isAuthenticated: "auth/isAuthenticated",
    }),
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    ...mapActions({
			gotoPrevStage: "app/prevOnboardingStage"
		}),
    handlePrevStage() {
			if (this.current !== 1) {
				this.gotoPrevStage(this.current-1)
			} else {
        return this.$router.push("/");
      }
		}
  },
  created() {
    // if (this.isAuthenticated) {
    //   this.$router.push({name: "Dashboard"})
    // }
  }
}


// WEBPACK FOOTER //
// ./src/views/mobile/auth/onboarding/index.ctrl.js